// generated by the plop

import { StandModel, TemplateModel } from 'shared';
import { PROGRESS_STATUSES, UUID } from 'symbols';

export interface StandManageStateModel {
  currentStandId: UUID;
  stands: { [standId: string]: StandModel };
  loadStandStatus: PROGRESS_STATUSES;
  updateStandStatus: PROGRESS_STATUSES;
  realVersionStands: { [standId: string]: StandModel };
  templateList: TemplateModel[];
  loadTemplateListStatus: PROGRESS_STATUSES;
}

export const STAND_MANAGE_STATE_DEFAULT: StandManageStateModel = {
  currentStandId: null,
  stands: {},
  loadStandStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  updateStandStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  realVersionStands: {},
  templateList: [],
  loadTemplateListStatus: PROGRESS_STATUSES.NOT_INITIALIZED
};
